import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TextInput from "./TextInput";
import AvatarDialog from "../pages/staff/components/AvatarDialog";
import ConfirmPopup from "./ConfirmPopup";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from 'react-redux';
import { currentUserActions } from '../reducers/currentUser';
import {
  getListChatTalent,
  getNumberMessagesTalent,
  setLoadingGetListChat,
} from "reducers/chatMessage";
import {getListNotification} from "reducers/talentHome";
import noAvatar from "../../assets/img/noAvatar.png";
import { pushGoogleAnalytics } from "../utils/gtag"
import { handleTalentSocketMessage } from "../utils/socket"
import LogoHeader from "components/LogoHeader";
import { MOBILE_SCREEN_WIDTH } from "../constants/index";
import { useMediaQuery } from 'react-responsive';
import useAppWebSocket from "../hooks/useAppWebSocket";

const productName = "aloop";

const TalentHeader = ({
  productNameMob = "",
  prevPage = { name: "", path: "", onClick: null, isDisabled: false },
  accountType = "user",
  searchInput = false,
  onSearchChange,
  searchQuery,
  onSearch,
  startIcon,
  button = null,
}: any) => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
  const navigate = useNavigate();
  const [avatar, setAvatar] = useState<any>(noAvatar);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [optionsOpen, setOptionsOpen] = useState(false);
  const currentUser = useSelector((state: any) => state.currentUser)
  const chatMessage = useSelector((state: any) => state.chatMessage)
  const { chatSelected, numberOfTalentMessage } = chatMessage
  let { socketInstance, talentInfo } = currentUser
  const { first_name, last_name, company } = currentUser.talentInfo
  const talentMypage = useSelector((state: any) => state.talentMypage)
  const talentCompanyData = talentMypage.talent;
  const isMobile = useMediaQuery({ maxWidth: MOBILE_SCREEN_WIDTH });

  const userName = last_name + " " + first_name;

  const { disconnect: disconnectSocket } = useAppWebSocket({
    groupPath: talentInfo?.id ? `talent-${talentInfo?.id}` : null,
    onMessage: (data) => {
      handleTalentSocketMessage(data, dispatch, chatMessage, isMobile);
    },
  });

  const signOutUser = () => {
    disconnectSocket();
    dispatch(currentUserActions.signOutUser({ navigate, view: 'talent' }));
  };
  const userOptions = [
    {
      name: "マイページ",
      onClick: () => navigate("/talent/mypage"),
    },
    {
      name: "ログアウト",
      onClick: signOutUser,
    },
  ];

  const handleAvatarChange = (file: any) => {
    if (!file) {
      setAvatar(noAvatar);
      setIsConfirmOpen(false);
    } else {
      setAvatar(URL.createObjectURL(file));
    }
    setDialogOpen(false);
  };

  const handleBlur = (event: any) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setOptionsOpen(false);
    }
  };



  // Google Analytics
  useEffect(() => {
    setTimeout(() => {
      addDataLayer()
    }, 5000);
  }, []);

  // Push Google Analytics
  const addDataLayer = () => {
    // Push data into dataLayer
    const data = {
      project: 'Alumni',
      event: 'gtm.load',
      js: new Date(),
      utm_source: 'tal_reg',
      utm_medium: talentInfo?.email
    }
    pushGoogleAnalytics(data);
  };

  useEffect(() => {
    if(talentInfo?.avatar) setAvatar(talentInfo.avatar);
    else setAvatar(noAvatar);
  }, [talentInfo?.avatar])

  return (
    <>
      {dialogOpen && (
        <AvatarDialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          onConfirm={handleAvatarChange}
          onConfirmPopupOpen={() => setIsConfirmOpen(true)}
        />
      )}
      {isConfirmOpen && (
        <ConfirmPopup
          open={isConfirmOpen}
          onClose={() => setIsConfirmOpen(false)}
          confirmContent={"現在使用しているプロフィール画像を削除しますか？"}
          onConfirm={() => handleAvatarChange(null)}
        />
      )}
      <div className={`px-4 md:px-6 py-2 ${productNameMob === "マイページ" ? "bg-white md:!bg-transparent" : "bg-transparent"} bg-transparent`}>
        <div className="flex items-center justify-between">
          <LogoHeader view="talent"></LogoHeader>
          {prevPage?.name ? (
            <div className="md:hidden flex items-center">
              <button
                disabled={prevPage?.isDisabled}
                onClick={() =>
                  prevPage?.path
                    ? navigate(`${prevPage?.path}`)
                    : prevPage?.onClick()
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M15.4102 16.59L10.8302 12L15.4102 7.41L14.0002 6L8.00016 12L14.0002 18L15.4102 16.59Z"
                    fill="#808080"
                  />
                </svg>
              </button>
              {startIcon?.icon && (
                <span
                  className="mx-1"
                  onClick={() => {
                    if (startIcon?.onClick) {
                      startIcon.onClick();
                    }
                  }}
                >
                  {startIcon?.icon}
                </span>
              )}
              <p className={`text-base font-bold ${prevPage?.isDisabled ? 'alu-text-base-1' : 'alu-text-base-2'}`} disabled={prevPage?.isDisabled}
                onClick={() =>
                  prevPage?.path
                    ? navigate(`${prevPage?.path}`)
                    : prevPage?.onClick()
                }>
                {prevPage?.name}
              </p>
            </div>
          ) : (
            <div className="flex items-center gap-4 md:hidden">
              {startIcon?.icon &&
                <>
                <span onClick={() => {
                  if (startIcon?.onClick) {
                    startIcon.onClick();
                  }
                }}>
                  {startIcon?.icon}
                  {productNameMob === "ALUMNI相談チャット" && numberOfTalentMessage != 0 &&
                    <span className="absolute md:static ml-6 top-3 left-3">
                      <svg
                        className="w-[0.5625rem] h-8 md:w-1 md:h:4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 4 16"
                        fill="none"
                      >
                        <circle cx="2" cy="2" r="2" fill="#FF861A" />
                      </svg>
                    </span>
                  }
                </span>

                </>
              }
              <h1
                className={`${
                  productNameMob === "ALUMNI相談チャット"
                    ? "text-xl"
                    : productNameMob === "ホーム"
                    ? "text-2xl"
                    : "text-2xl"
                } font-bold alu-text-base-2 md:hidden`}
              >
                {productNameMob ? productNameMob : productName}
              </h1>
              {button && (
                button
              )}
            </div>
          )}
          <div
            onBlur={handleBlur}
            tabIndex={-1}
            className="flex items-center relative cursor-pointer"
            onClick={() => setOptionsOpen((prev) => !prev)}
          >
            {optionsOpen && (
              <ul
              className="z-[99] min-w-[10rem] rounded absolute top-[calc(100%+8px)] right-0 py-2 bg-white alu-options-box-shadow"
            >
                {userOptions.map((option, idx) => (
                  <li
                    tabIndex={0}
                    key={idx}
                    className="px-4 py-2 rounded flex items-center gap-2 hover:bg-[#FFF3E5] hover:cursor-pointer"
                    onClick={() => option?.onClick()}
                  >
                    <p className="text-base alu-text-base-2">
                      {option.name}
                    </p>
                  </li>
                ))}
              </ul>
            )}
            <img
              src={avatar}
              alt="profile"
              className="w-8 h-8 rounded-full object-cover block md:hidden"
            />
            <h2 className={"hidden md:block ml-2 mr-[0.625rem] text-sm font-semibold tracking-[-0.28px] leading-[18.2px] alu-text-base-2"}>
              {company?.name}
            </h2>
            <button className="hidden md:block">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g clipPath="url(#clip0_8574_176)">
                  <path d="M7 10L12 15L17 10H7Z" fill="#343A3D" />
                </g>
                <defs>
                  <clipPath id="clip0_8574_176">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </button>
          </div>
        </div>
        <h2 className={`max-w-[calc(100%-48px)] truncate ${productNameMob == "メッセージ" ? "hidden" : ""} md:hidden text-xs font-bold alu-text-base-1 mt-1 ${prevPage?.name ? "pl-6" : ""}`}>{currentUser?.talentInfo?.company?.name}</h2>
        {searchInput && (
          <div className="md:hidden mt-2">
            <TextInput
              id="search"
              name="search"
              value={searchQuery}
              onChange={(e: any) => onSearchChange(e.target.value)}
              onClearQuery={() => onSearchChange("")}
              onKeyDown={(e: any) => e.key === "Enter" && onSearch()}
              placeholder="検索"
              searchIcon={true}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default TalentHeader;